var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Avatar from '@material-ui/core/Avatar';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Downshift from 'downshift';
import { camelCase, startCase } from 'lodash';
import React from 'react';
import { divider } from '../../Styles/Colours';
import { AvatarIcon } from '../Icons';
import { MaskedTextField } from '../MaskedTextField';
import { StyledChip } from '../StyledChip';
import styles from './MultiSelectWithChips.module.css';
// DEPRECATED - use StyledSelect instead
function renderSuggestion(_a) {
    var suggestion = _a.suggestion, index = _a.index, itemProps = _a.itemProps, itemToString = _a.itemToString, itemToMenuKey = _a.itemToMenuKey, customItemRender = _a.customItemRender, highlightedIndex = _a.highlightedIndex, selectedItems = _a.selectedItems;
    var isHighlighted = highlightedIndex === index;
    if (isNewType(suggestion)) {
        var newItemName = startCase(suggestion.value.toLowerCase()).trim();
        return (React.createElement(MenuItem, __assign({}, itemProps, { key: 'create-new-item', selected: isHighlighted, component: 'div', style: {
                fontWeight: 400,
                borderBottom: "1px solid " + divider,
                paddingTop: 8,
                paddingBottom: 7,
                maxWidth: '100%',
                textOverflow: 'ellipsis'
            } }),
            "Create new '",
            newItemName,
            "'"));
    }
    else {
        var indexOf = selectedItems.findIndex(function (item) { return itemToMenuKey(item) === itemToMenuKey(suggestion); });
        var isSelected = indexOf > -1;
        return (React.createElement(MenuItem, __assign({}, itemProps, { key: itemToMenuKey ? itemToMenuKey(suggestion) : itemToString(suggestion), selected: isHighlighted, component: 'div', style: {
                fontWeight: isSelected ? 500 : 400,
                borderBottom: "1px solid " + divider,
                paddingTop: 8,
                paddingBottom: 7,
                maxWidth: '100%',
                textOverflow: 'ellipsis'
            } }),
            isSelected && React.createElement(Icon, { style: { marginRight: 6 } }, "check"),
            customItemRender ? customItemRender(suggestion) : itemToString(suggestion)));
    }
}
function isNewType(item) {
    return item.type === 'new';
}
var MultiSelectWithChips = /** @class */ (function (_super) {
    __extends(MultiSelectWithChips, _super);
    function MultiSelectWithChips() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputElement = null;
        _this.textFieldContainer = null;
        _this.state = {
            inputValue: ''
        };
        _this.handleChange = function (selectedItem) {
            if (isNewType(selectedItem)) {
                if (_this.props.onCreateNew) {
                    _this.props.onCreateNew(selectedItem.value);
                }
                return;
            }
            if (!selectedItem)
                return;
            if (_this.props.disabled)
                return;
            if (_this.props.readOnly)
                return;
            var values = [];
            if (_this.props.singleMode) {
                values = [selectedItem];
            }
            else {
                var itemExists_1 = _this.props.values.find(function (chosenItem) { return _this.props.compareItems(chosenItem, selectedItem); });
                if (!itemExists_1) {
                    values = __spreadArray(__spreadArray([], __read(_this.props.values), false), [selectedItem], false);
                }
                else {
                    values = _this.props.values.filter(function (it) { return !_this.props.compareItems(it, itemExists_1); });
                }
            }
            _this.setState({
                inputValue: ''
            });
            if (_this.props.onSelection)
                _this.props.onSelection(values);
        };
        _this.handleDelete = function (item) { return function () {
            if (_this.props.disabled)
                return;
            if (_this.props.readOnly)
                return;
            var values = __spreadArray([], __read(_this.props.values), false);
            values.splice(values.indexOf(item), 1);
            if (_this.props.onSelection)
                _this.props.onSelection(values);
        }; };
        _this.handleKeyDown = function (event) {
            if (_this.props.disabled)
                return;
            if (_this.props.readOnly)
                return;
            var inputValue = _this.state.inputValue;
            var values = __spreadArray([], __read(_this.props.values), false);
            if (values.length > 0 && !inputValue.length && event.keyCode === 8 && !!_this.props.onSelection) {
                var newValues = values.slice(0, values.length - 1);
                _this.props.onSelection(newValues);
            }
        };
        _this.changeInputValue = function (value) {
            if (_this.props.disabled)
                return;
            if (_this.props.readOnly)
                return;
            _this.setState({
                inputValue: value
            });
        };
        _this.handleInputValueChange = function (value, stateAndHelpers) {
            if (_this.props.disabled)
                return;
            if (_this.props.readOnly)
                return;
            _this.setState({
                inputValue: value
            });
            if (stateAndHelpers && stateAndHelpers.type === Downshift.stateChangeTypes.changeInput)
                if (_this.props.onChange)
                    _this.props.onChange(value);
        };
        _this.bindInput = function (element) {
            _this.inputElement = element;
        };
        _this.bindTextFieldContainer = function (element) {
            _this.textFieldContainer = element;
        };
        _this.childrenFunction = function (_a) {
            var getInputProps = _a.getInputProps, getItemProps = _a.getItemProps, isOpen = _a.isOpen, inputValue = _a.inputValue, selectedItem = _a.selectedItem, openMenu = _a.openMenu, closeMenu = _a.closeMenu, highlightedIndex = _a.highlightedIndex;
            var inputProps = getInputProps();
            var avatarIcon = (React.createElement(Avatar, { className: styles.chipAvatar }, _this.props.chipIcon ? (_this.props.chipIcon(selectedItem, {
                disabled: !!_this.props.readOnly
            })) : (React.createElement(AvatarIcon, { size: '24', color: 'lightGrey' }))));
            if (!isOpen && _this.props.getStartAdornment)
                inputProps.startAdornment = _this.props.getStartAdornment(selectedItem);
            inputProps.startAdornment = (React.createElement(React.Fragment, null,
                _this.props.values.map(function (item, index) { return (React.createElement(StyledChip, { disabled: _this.props.readOnly, label: _this.props.itemToString(item), maxLength: _this.props.maxChipLength ? _this.props.maxChipLength : 30, hasAccent: true, avatar: avatarIcon, testId: "chip-" + index, key: _this.props.itemToString(item) + "-" + index, onRemove: _this.handleDelete(item) })); }),
                !isOpen && _this.props.getStartAdornment && _this.props.getStartAdornment(selectedItem)));
            var handleInputClick = function (e) {
                if (_this.props.disabled)
                    return;
                if (_this.props.readOnly)
                    return;
                if (isOpen) {
                    closeMenu();
                }
                else {
                    openMenu();
                    if (_this.props.onClick)
                        _this.props.onClick(e);
                }
            };
            var handleInputBlur = function (e) {
                if (_this.props.disabled)
                    return;
                if (_this.props.readOnly)
                    return;
                _this.changeInputValue('');
                if (inputProps.onBlur)
                    inputProps.onBlur(e);
            };
            var handleKeyDown = function (e) {
                if (_this.props.disabled)
                    return;
                if (_this.props.readOnly)
                    return;
                _this.handleKeyDown(e);
                if (inputProps.onKeyDown)
                    inputProps.onKeyDown(e);
            };
            var testId = camelCase(_this.props.label);
            var width = _this.textFieldContainer ? _this.textFieldContainer.clientWidth : 0;
            var handleChangeInput = function (value, event) { return inputProps.onChange(event); };
            return (React.createElement("div", { className: styles.container, "data-test-id": "multiSelectWithChips_" + testId },
                React.createElement("div", { ref: _this.bindTextFieldContainer, className: styles.inputContainer },
                    React.createElement(MaskedTextField, __assign({}, inputProps, { disabled: _this.props.disabled, readOnly: _this.props.readOnly, autoFocus: _this.props.autoFocus, label: _this.props.label || ' ', errorText: _this.props.errorText, warningText: _this.props.warningText, fullWidth: true, inputClasses: {
                            root: styles.inputRoot,
                            input: styles.input
                        }, onClick: handleInputClick, onKeyDown: handleKeyDown, onBlur: handleInputBlur, onFocus: _this.props.onFocus, inputRef: _this.bindInput, required: _this.props.required, onChange: handleChangeInput, endAdornment: undefined, testId: testId }))),
                React.createElement(Popper, { open: isOpen && !_this.props.disabled, anchorEl: _this.textFieldContainer, modifiers: {
                        flip: {
                            enabled: false
                        },
                        offset: { offset: '0, -17px' },
                        preventOverflow: {
                            enabled: false,
                            boundariesElement: 'scrollParent'
                        },
                        hide: {
                            enabled: false
                        },
                        arrow: {
                            enabled: false
                        }
                    }, style: { zIndex: 99 }, disablePortal: true },
                    React.createElement(Paper, { style: { width: width }, square: true },
                        _this.getSuggestions(inputValue || '')
                            .filter(function (suggestion, index) {
                            return _this.props.maxResults ? index < _this.props.maxResults : true;
                        })
                            .map(function (suggestion, index) {
                            return renderSuggestion({
                                suggestion: suggestion,
                                itemToString: _this.props.itemToString,
                                index: index,
                                itemProps: getItemProps({ item: suggestion }),
                                itemToMenuKey: _this.props.itemToMenuKey,
                                customItemRender: _this.props.customItemRender,
                                highlightedIndex: highlightedIndex,
                                selectedItems: _this.props.values
                            });
                        }),
                        _this.props.maxResults &&
                            _this.getSuggestions(inputValue || '').length > _this.props.maxResults && (React.createElement(Typography, { className: styles.maxResults }, "More results found - type to refine"))))));
        };
        return _this;
    }
    MultiSelectWithChips.prototype.getSuggestions = function (inputValue) {
        if (this.props.onCreateNew && !!inputValue.trim()) {
            return __spreadArray(__spreadArray([], __read(this.props.suggestions), false), [
                {
                    type: 'new',
                    value: inputValue
                }
            ], false);
        }
        else {
            return this.props.suggestions;
        }
    };
    MultiSelectWithChips.prototype.render = function () {
        return (React.createElement("div", { className: styles.root },
            React.createElement(Downshift, { inputValue: this.state.inputValue, defaultHighlightedIndex: 0, onInputValueChange: this.handleInputValueChange, onChange: this.handleChange, itemToString: this.props.itemToString, selectedItem: null }, this.childrenFunction)));
    };
    MultiSelectWithChips.defaultProps = {
        maxResults: 5
    };
    return MultiSelectWithChips;
}(React.Component));
export { MultiSelectWithChips };
